export default __webpack_public_path__ + "static/media/position_icon.d50f5111.svg";